import { Autocomplete, TextField, Stack, Box } from '@mui/material';
import { StringType } from '../types';
import { useState, useRef } from 'react';
import { useScrollIntoView } from '../hooks/useScrollIntoView';

interface Props {
  stringTypes: StringType[];
  crossesId: string;
  onSelectCrosses: (id: string) => void;
  crossesTension: number | null;
  onChangeCrossesTension: (val: number | null) => void;
}

const getOptionLabel = (option: StringType) => {
  return option.id === 'add-string' ? option.brand : `${option.brand} ${option.name}${option.gauge ? ' ' + option.gauge : ''}${option.color ? ' ' + option.color : ''}`
}

export default function StepCrossesForm({
  stringTypes,
  crossesId,
  onSelectCrosses,
  crossesTension,
  onChangeCrossesTension,
}: Props) {
  const scrollIntoView = useScrollIntoView();
  const autocompleteRef = useRef<HTMLDivElement>(null);
  const [inputValue, setInputValue] = useState('');

  const filteredOptions = stringTypes.filter((opt) =>
    `${opt.brand} ${opt.name} ${opt.gauge || ''} ${opt.color || ''}`
      .toLowerCase()
      .includes(inputValue.toLowerCase())
  );

  const options = [
    { id: 'add-string', brand: '+ Add new string', name: '', gauge: '', color: '', material: 'POLYESTER' } as StringType,
    ...filteredOptions,
  ];

  const handleAutocompleteOpen = () => {
    setTimeout(() => {
      const input = autocompleteRef.current?.querySelector('input') || document.activeElement as HTMLInputElement;
      if (input && input instanceof HTMLInputElement) {
        scrollIntoView(input);
      }
    }, 100);
  };

  const handleTextFieldFocus = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    scrollIntoView(e.target);
  };

  return (
    <Stack spacing={2}>
      <Autocomplete
        ref={autocompleteRef}
        options={options}
        getOptionLabel={(option) =>
          getOptionLabel(option)
        }
        renderOption={(props, option) => {
          return (
            <li {...props}>
              <Box
                component="span"
                sx={{ fontStyle: option.id === 'add-string' ? 'italic' : 'normal' }}
              >
                {getOptionLabel(option)}
              </Box>
            </li>
          );
        }}
        value={stringTypes.find((s) => s.id === crossesId) || null}
        onChange={(_, newValue) => {
          if (newValue) onSelectCrosses(newValue.id);
        }}
        inputValue={inputValue}
        onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
        onOpen={handleAutocompleteOpen}
        renderInput={(params) => <TextField {...params} label="Crosses String" />}
      />

      <TextField
        label="Crosses Tension (lbs)"
        type="number"
        value={crossesTension ?? ''}
        onChange={(e) =>
          onChangeCrossesTension(e.target.value ? parseInt(e.target.value, 10) : null)
        }
        onFocus={handleTextFieldFocus}
      />
    </Stack>
  );
}
